import { useEffect, useState } from 'react'
import { api, type ApiError } from '../lib/api'
import { navigate } from '../lib/router'
import { AuthLayout } from '../components/auth/AuthLayout'
import { Button } from '../components/ui/button'
import { StatusBox } from '../components/ui/badge'

type Status = 'verifying' | 'success' | 'error'

export function VerifyEmailPage() {
  const [status, setStatus] = useState<Status>('verifying')
  const [message, setMessage] = useState<string>('Verifying your email…')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    if (!token) {
      setStatus('error')
      setMessage('Missing verification token.')
      return
    }
    api
      .verifyEmail(token)
      .then(() => {
        setStatus('success')
        setMessage('Your email is verified. You can now use all of Doable.')
      })
      .catch((err: ApiError) => {
        setStatus('error')
        setMessage(err.title ?? 'Verification failed.')
      })
  }, [])

  const tone = status === 'success' ? 'success' : status === 'error' ? 'destructive' : 'volt'

  return (
    <AuthLayout
      title="Email verification"
      panel={{ line1: 'One last check.', line2: 'Confirming the address you signed up with.' }}
    >
      <div className="space-y-4">
        <StatusBox tone={tone}>{message}</StatusBox>
        <Button size="auth" onClick={() => navigate('/dashboard')}>
          Continue to dashboard
        </Button>
      </div>
    </AuthLayout>
  )
}
